import { createContext, type ReactNode } from "react";

/**
 * On the run graph, what an open step card shows of its Run under its settings, by the step's progress key: what its
 * prompt is filled with before it runs (F148). The Run's page provides it; the Workflow graph has none.
 */
export const RunStepDetails = createContext<((progressKey: string) => ReactNode) | null>(null);
